export default __webpack_public_path__ + "static/media/fuel_bowser.323c239d.jpg";